import { createFileRoute } from "@tanstack/react-router";
import { KeyRound } from "lucide-react";
import { UserAccountsAdminCard } from "@/components/account/UserAccountsAdminCard";

export const Route = createFileRoute("/_authenticated/m/contas-responsavel")({
  component: ContasResponsavelPage,
});

function ContasResponsavelPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <KeyRound className="h-7 w-7 text-primary" />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Conta de Acesso</h1>
          <p className="text-muted-foreground text-sm">
            Contas de acesso vinculadas ao seu Centro de Treinamento.
          </p>
        </div>
      </div>
      <UserAccountsAdminCard />
    </div>
  );
}
